import { useState } from "react";
import { updateRemovesVisitorGrants } from "../../../shared/connectors/grantBinding";
import { ConfirmModal } from "../ConfirmModal";
import type { App } from "./Form";

type Pending = { save: () => void; cancel: () => void };
type Update = Parameters<typeof updateRemovesVisitorGrants>[1];

export function useConfirmGrantRemoval(app: App) {
  "use memo";
  const [pending, setPending] = useState<Pending>();

  const removesGrants = (update: Update) =>
    !!app.visitorGrants?.length && updateRemovesVisitorGrants(app, update);

  const confirmGrantRemoval = <T,>(
    update: Update,
    save: () => T,
    cancel: () => void
  ): T | undefined => {
    if (removesGrants(update)) {
      setPending({ save, cancel });
      return undefined;
    }
    return save();
  };

  const confirmModal = (
    <ConfirmModal
      open={pending !== undefined}
      onClose={() => {
        pending?.cancel();
        setPending(undefined);
      }}
      onConfirm={() => {
        pending?.save();
        setPending(undefined);
      }}
      title="Remove all connected accounts?"
      description="This change disconnects every account connected to this connector. People will need to connect again."
      confirmLabel="Save"
      destructive
    />
  );

  return { removesGrants, confirmGrantRemoval, confirmModal };
}
